// Trivial so ignore in test coverage
/* istanbul ignore next */
export const reloadPage = () => {
  window.location.reload();
};
